<template>
<div id="auth">
  <h3>Sign In</h3>

  <form
    class="form-horizontal"
    method="post"
    :action="this.apiUrl(userUrl)"
    v-on:submit.prevent="submit"
  >

    <div class="form-group">
      <label for="user_email" class="required">
        Email Address
      </label>

      <input type="text"
        class="form-control"
        id="user_email"
        placeholder="Enter Email Address"
        autofocus="true"
        required="true"
        name="user[email]"
        v-model="auth_key"
      />
    </div>

    <div class="form-group">
      <label
        for="user_password"
        class="d-block required"
      >
        Password

        <a
          href=""
          class="float-right"
          v-on:click.prevent="toggleShowPassword"
        >
          {{ passwordShowStr }}
        </a>
      </label>

      <input
        :type="passwordType"
        class="form-control"
        id="user_password"
        placeholder="Password"
        required="true"
        name="user[password]"
        v-model="password"
      >
    </div>

    <div class="form-group">
      <button
        type="submit"
        class="btn btn-primary form-control"
      >
        Sign In
      </button>
    </div>
  </form>
  <p
    class="text-right"
  >
    <router-link
      :to="{
        name: 'request_password_reset'
      }"
    >
      Reset Password
    </router-link>
  </p>
</div>
</template>

<script>
import Flash from '@/components/Flash'
import PasswordMixin from '@/mixins/PasswordMixin'
import FlashStore from '@/stores/FlashStore'

import AuthStore from '@/stores/AuthStore'

export default {
  components: {
    'flash': Flash
  },

  created () {
    this.$store.dispatch(
      `SettingModule/getPublicSettings`
    ).catch(this.$root.processErrors)

    AuthStore.dispatch('clearAuth').then(() => {
      this.$parent.currentUser = {}
    })
  },

  data () {
    return {
      currentUser: undefined,
      loggedIn: false,
      privateState: {},
      sharedState: AuthStore.state,
      auth_key: undefined,
      password: undefined,
      role_alias: undefined,
      auth_type: 'email',
      auth_types: [
        {
          name: 'Email'
        }
      ]
    }
  },

  computed: {
    auth_type_value () {
      return this.auth_type.toLowerCase()
    },

    userCreate () {
      return this.userAction === 'create'
    },

    userUrl () {
      return '/users' + (this.userCreate ? '' : '/authenticate')
    }
  },

  props: ['userAction'],

  mixins: [ PasswordMixin ],

  methods: {
    validateFields () {

    },

    submit (ev) {
      const target = ev.target

      let formData = new FormData(target)

      let formInstance = target
      let method = formInstance.getAttribute('method').toLowerCase()

      return this.$http[method](target.action, formData).then((resp) => {
        let hdrs = resp.headers
        let processed = this.processSuccess(resp)

        this.currentUser = {
          id: processed.id,
          name: processed.name,
          username: processed.username,
          'X-Auth-Key': hdrs.get('X-Auth-Key'),
          'X-Auth-Token': hdrs.get('X-Auth-Token'),
          'X-Auth-Type': hdrs.get('X-Auth-Type'),
          role_alias: processed.role.attributes.alias
        }

        AuthStore.dispatch('setAuth', this.currentUser).then(resp => {
          this.$parent.currentUser = this.currentUser

          if (
            this.currentUser.role_alias !== 'admin' && this.currentUser.role_alias !== 'support_user'
          ) {
            FlashStore.errors(
              ['Invalid user role']
            )

            return
          }

          this.$store.dispatch(
            `SettingModule/getSettings`
          ).catch(this.$root.processErrors)

          this.$router.push({
            name: 'home'
          })
        })
      }, this.processErrors)
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Auth.vue